import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Divider, useTheme } from '@mui/material';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

interface WidgetTooltipProps extends TooltipProps<ValueType, NameType> {
  children: React.ReactNode;
}

const WidgetTooltip = ({ active, payload, children }: WidgetTooltipProps) => {
  const theme = useTheme();

  if (active && payload?.length) {
    return (
      <Box
        sx={{
          backgroundColor: theme.palette.colors.neutrals[850],
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '12px',
          padding: '8px 16px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          minWidth: '250px',
          fontSize: '13px',
          color: 'var(--color-content-immutable-white)',
          ...flex.col,
          gap: 1,
        }}>
        {children}
      </Box>
    );
  }

  return null;
};

export default WidgetTooltip;

export const TooltipDivider = () => {
  const theme = useTheme();
  return <Divider sx={{ borderColor: theme.palette.colors.neutrals[650] }} />;
};
